import { Fragment } from 'react';
import styles from './LettersBanner.module.css';
import type { Letters } from '@/domain/scoring';

const COLORS = ['var(--color-l1)', 'var(--color-l2)', 'var(--color-l3)'];

function Connector({ color }: { color: string }) {
  return (
    <div className={styles.connector}>
      <svg width="30" height="20" viewBox="0 0 30 20" fill="none">
        <path d="M2 10 H22" stroke={color} strokeWidth="2" strokeDasharray="3 4" strokeLinecap="round" opacity="0.8" />
        <path d="M18 5 L24 10 L18 15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}

export function LettersBanner({
  letters,
  size = 'sm',
}: {
  letters: Letters;
  size?: 'lg' | 'sm';
}) {
  const tileClass = size === 'lg' ? styles.tileLg : styles.tileSm;
  return (
    <div className={styles.row}>
      {letters.map((ch, i) => (
        <Fragment key={i}>
          <div
            className={`${styles.tile} ${tileClass}`}
            style={{ color: COLORS[i] } as React.CSSProperties}
          >
            <span className={styles.num}>{i + 1}</span>
            {ch.toUpperCase()}
          </div>
          {i < letters.length - 1 && <Connector color={COLORS[i + 1]} />}
        </Fragment>
      ))}
    </div>
  );
}
